"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.laneOverrideSchema = exports.laneOverrideInputSchema = exports.laneOverrideParamsSchema = void 0;
// A nurse's manual lane override (`RPM-017`, `CR-7`, `J-217`).
//
// AN OVERRIDE THE MACHINE CAN UNDO IS NOT AN OVERRIDE. That is `CR-7` and the requirement's own
// Rationale: "the audit then shows a lane nobody chose." So the override is a stored judgement with
// an actor, a reason and an instant, and `DT-OVERRIDE-SURVIVAL` decides what a later re-resolution
// does to it.
//
// THE REASON IS REQUIRED AT THE CONTRACT BOUNDARY, which is one of the two defences `RPM-017`'s
// Blocking row asks for: "A missing reason is `400` at the contract boundary and a disabled confirm
// control in the surface. Two defences."
const zod_1 = require("zod");
const rpm_enums_js_1 = require("./db/rpm-enums.js");
exports.laneOverrideParamsSchema = zod_1.z.strictObject({ alertId: zod_1.z.uuid() });
exports.laneOverrideInputSchema = zod_1.z
    .strictObject({
    /**
     * Any value the vocabulary allows — "A nurse may set the lane to any value the vocabulary
     * allows." `alert_lane` and not `auto_lane`: `GRAY` is a BAND that a resolution turns into
     * `MACHINE`, and it is not a lane anybody stands on.
     */
    lane: zod_1.z.enum(rpm_enums_js_1.alertLane.enumValues),
    /**
     * Why. `min(1)` is the `400` the Blocking row asks for at this boundary, and `trim()` comes
     * first so a reason made only of spaces is no reason (`RPM-017` row 4, `J-702`): the same shape
     * as the suppression override's (`rpm-alert-routing.ts`).
     */
    reason: zod_1.z.string().trim().min(1).max(500),
})
    .meta({ description: "The lane she finalised, and why" });
exports.laneOverrideSchema = zod_1.z
    .strictObject({
    rpmAlertId: zod_1.z.uuid(),
    /**
     * WHAT THE MACHINE COMPUTED, kept (`RPM-017`'s Postcondition: "`auto_lane` still holds what the
     * machine computed; `lane` holds what the nurse finalised; both are readable forever").
     *
     * `auto_lane` AND NOT `alert_lane`, and the two enums differ by one member on purpose
     * (`rpm-enums.ts:130`): "autoLane has GRAY and alertLane does not: two enums rather than one with
     * a check constraint, so the impossible state is unrepresentable in the type drizzle-zod projects
     * into the API contract." The machine may compute `GRAY`; a nurse never stands an alert on it.
     */
    autoLane: zod_1.z.enum(rpm_enums_js_1.autoLane.enumValues).nullable(),
    /** What she finalised. */
    lane: zod_1.z.enum(rpm_enums_js_1.alertLane.enumValues).nullable(),
    laneOverridden: zod_1.z.boolean(),
    laneOverriddenBy: zod_1.z.uuid().nullable(),
    laneOverriddenAt: zod_1.z.iso.datetime().nullable(),
    /**
     * The suggestion line's two halves, so the surface names both lanes where they differ rather
     * than composing a sentence from data it would have to re-derive (`RPM-017`'s Operator surface).
     */
    disagrees: zod_1.z.boolean(),
})
    .meta({ id: "LaneOverride", description: "The lane that stands, and whether a human chose it" });
//# sourceMappingURL=rpm-lane-override.js.map